import { isPasswordLoginPrimary } from '@/configuration/ssoProviders';
import { DEFAULT_PLAYER_INSTALLER_DOWNLOAD_URL } from '@/constants';

export const apiUrl = () => {
  return window.SENTOA_APP_CORE_URL;
};

export const webSocketApiUrl = () => {
  return window.SENTOA_APP_WEB_SOCKET_URL;
};

/**
 * Blob URL of the Sentoa Player installer for this CMS environment. A function rather than a
 * constant, and called at the point of use, so a config.js loaded after this module still wins.
 *
 * `??` and not `||`: an operator who deliberately blanks the key gets a visibly broken button
 * rather than a silent fall back to the production installer.
 */
export const playerInstallerDownloadUrl = () => {
  return window.PLAYER_INSTALLER_DOWNLOAD_URL ?? DEFAULT_PLAYER_INSTALLER_DOWNLOAD_URL;
};

/**
 * Self sign-up ends with the new user setting a password, so it is only offered where password
 * login is on the main login surface. An environment that hides password login, or leaves it out,
 * gets no registration flow whatever SELF_SIGN_UP_ENABLED says.
 */
export const isSelfSignUpEnabled = () => {
  return (window.SELF_SIGN_UP_ENABLED ?? true) && isPasswordLoginPrimary;
};

export const isSupportChatEnabled = () => {
  return window.SUPPORT_CHAT_ENABLED ?? false;
};
